import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios'; 
import ClipLoader from 'react-spinners/ClipLoader'; 
import './QuizQuestionComponent.css';
import { COURSES_URL } from '../../Services/courseService';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuizQuestionComponent = () => {
  const { id } = useParams();
  const [quizzes, setQuizzes] = useState([]);
  const [userAnswers, setUserAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentQuizIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [quizResult, setQuizResult] = useState(null);
  const [isQuizSubmitted, setIsQuizSubmitted] = useState(false);
   const [isPopupVisible, setIsPopupVisible] = useState(false);

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const response = await axios.get(`${COURSES_URL}/quizzes`);
        const filteredQuizzes = response.data.filter(quiz => quiz.course.courseId === id);
        setQuizzes(filteredQuizzes);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching quizzes:', error);
         setLoading(false);
      }
    };

    fetchQuizzes();
  }, [id]);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const quizId = quizzes[currentQuizIndex]?.id;
    const quizStatusKey = `${userId}Q${quizId}`;

    if (quizId && localStorage.getItem(quizStatusKey)) {
      setIsQuizSubmitted(true);
      fetchQuizResult(userId, quizId);
    }
  }, [quizzes, currentQuizIndex]);

  const handleAnswerChange = (quizId, questionId, answerValue) => {
    setUserAnswers(prevAnswers => ({
      ...prevAnswers,
      [`${quizId}-${questionId}`]: answerValue,
    }));
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < quizzes[currentQuizIndex]?.questions?.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem('userId');
    const quizId = quizzes[currentQuizIndex]?.id;
    const quizStatusKey = `${userId}Q${quizId}`;

    setLoading(true);

    if (localStorage.getItem(quizStatusKey)) {
      // toast.info('Quiz already submitted. Fetching your score...');
      fetchQuizResult(userId, quizId);
      return;
    }

    const submittedAnswers = quizzes[currentQuizIndex].questions.map(question => ({
      questionId: question?.id,
      selectedAnswer: userAnswers[`${quizId}-${question?.id}`] || null,
    }));

    const data = {
      userId: Number(userId),
      quizId: quizId,
      submittedAnswers: submittedAnswers,
    };

    try {
      const response = await axios.post(`${COURSES_URL}/quizzes/submit-quiz`, data);
      if (response.status === 200) {
        // toast.success('Quiz submitted successfully!');
        localStorage.setItem(quizStatusKey, true);
        setIsQuizSubmitted(true);
        fetchQuizResult(userId, quizId);
      }
    } catch (error) {
      console.error('Error submitting quiz:', error);
      // toast.error('Error submitting quiz');
      if (error.response?.status === 500) {
        fetchQuizResult(userId, quizId);
        localStorage.setItem(quizStatusKey, true);
      }
    }
    finally{
      setLoading(false);

    }
  };

  const fetchQuizResult = async (userId, quizId) => {
    try {
      const response = await axios.get(`${COURSES_URL}/quizzes/quiz-result/${userId}/${quizId}`);
      setQuizResult(response.data);
      setIsQuizSubmitted(true);
    } catch (error) {
      console.error('Error fetching quiz result:', error);
      // toast.error('Error fetching quiz result');
    }
  };
 


  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#333" loading={loading} size={25} />
      </div>
    );
  }

  if (quizzes.length === 0) {
    return <p className='quiz-not-available'>No quizzes available for this course.</p>;
  }

  const currentQuiz = quizzes[currentQuizIndex];
  const currentQuestion = currentQuiz?.questions[currentQuestionIndex];

  if (!currentQuestion) {
    return <p>Loading question...</p>;
  }

  const isAnswerSelected = userAnswers[`${currentQuiz.id}-${currentQuestion.id}`] !== undefined;

  const handleShowQuiz = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="quiz-content-container">
      <h3 className='course-learnings-title'>Quiz</h3>
      {isQuizSubmitted ? (
        <div>
          {quizResult ? (
            <div>
              <h2 className='quiz-content-heading'>Quiz Attempt Summary</h2>
              <p>{`Total Questions: ${quizResult.totalQuestions}, Correct Answers: ${quizResult.correctAnswers}`}</p>
              <p>{`Score: ${Math.round(quizResult.score)}%`}</p>
            </div>
          ) : (
            <ClipLoader color="#333" loading={loading} size={50} />
          )}
        </div>
      ) : (
        <div className="quiz-container">
          { (
            <button  className="ES-button"  onClick={handleShowQuiz}>
              Show Quiz
            </button>
          )}

          {isPopupVisible && (
            <div className="quiz-popup-overlay">
              <div className="quiz-popup">
              <p className='quiz-question-number'>Question {String(currentQuestionIndex + 1).padStart(2, '0')}</p>
              <button className="close-popup" onClick={handleClosePopup}>
                  ✕
                </button>
                <form onSubmit={handleSubmit} className="quiz-form">
                   <div className="quiz-header">
                    <h3>{currentQuestion?.questions}</h3>
                  </div> 

                  <div className="quiz-options">
                    {currentQuestion?.answers?.map((answer, index) => {
                      const isSelected = userAnswers[`${currentQuiz?.id}-${currentQuestion?.id}`] === answer?.answer;
                      return (
                        <div key={index} className="quiz-option">
                         
                          <label>
                            <input
                              type="radio"
                              className="radio-quiz-option"
                              name={`${currentQuiz?.id}-${currentQuestion?.id}`}
                              value={answer?.answer}
                              onChange={() => handleAnswerChange(currentQuiz?.id, currentQuestion?.id, answer?.answer)}
                              checked={isSelected}
                              style={{ display: 'none' }}
                            />
                            <span
                              className="number"
                              style={{
                                marginRight: '10px',
                                fontSize: '20px', 
                              }}
                            > 
                            {isSelected && <FontAwesomeIcon icon={faCheck} size='50px' style={{ marginLeft:'2px' ,marginBottom: '10px' , color: 'var(--nav-buttons-text)' }}      className={`checkmark ${isSelected ? 'selected' : ''}`}                            />}
                            </span>
                            
                            <p style={{color: isSelected && '#0B89C2'}}>{answer?.answer}</p>
                          </label>
                        </div>
                      );
                    })}
                  </div> 
                  <div className="quiz-navigation">
                    {currentQuestionIndex > 0 && (
                      <button
                        type="button"
                        className="previous-button"
                        onClick={handlePreviousQuestion}
                      >
                        Previous
                      </button>
                    )}
                    {currentQuestionIndex < currentQuiz?.questions?.length - 1 ? (
                      <button
                        type="button"
                        className="next-button"
                        onClick={handleNextQuestion}
                        disabled={!isAnswerSelected}
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="submit-button"
                        disabled={Object.keys(userAnswers)?.length < currentQuiz?.questions?.length}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizQuestionComponent;
